import React from 'react';

import * as AppConstants from '../../../app/AppConstants';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function CCPProcedureDialog(props) {
  const isOpen = props.isOpen;
  const ccpUrl = props.ccpUrl;

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        {AppConstants.APPLICATION_PAYMENT_METHOD.CCP.NAME}
      </DialogTitle>
      <DialogContent style={{fontSize: 15}}>
        { !!ccpUrl && <>Please settle the fee <a href={ccpUrl} target="_blank">HERE</a>. </> }
        Please bring along the receipt to the {props.office}. Please keep the payment receipt for future reference.
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CCPProcedureDialog;
